import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';

type BlogArticleLinkProps = Omit<LinkProps, 'to'> & {
  slug: string;
};

const BlogArticleLink: React.FC<BlogArticleLinkProps> = ({
  slug,
  children,
  ...rest
}) => (
  <Link
    {...rest}
    to={`/blog/${slug}`}
    reloadDocument
    data-blog-route-navigation="document"
  >
    {children}
  </Link>
);

export default BlogArticleLink;
